import React, { FC } from 'react';

interface Props {
	className?: string;
}

export const VerticalAspectRatioIcon: FC<Props> = ({ className }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="33" height="66" xmlSpace="preserve" stroke="none">
			<path d="M33 66H0V0h33v66zM1 65h31V1H1v64z" />
			<path d="M13.5 36.7h-2.2v-5.6c-.1.2-.3.3-.5.5l-.8.8L8.9 31l2.7-2.2h1.9v7.9zM15.4 31.6c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM24.1 36.7h-5.7v-1.4l1.9-1.9c.5-.6.9-1 1.1-1.2.2-.2.3-.4.4-.5.1-.2.1-.3.1-.5s-.1-.4-.2-.5c-.1-.1-.3-.2-.6-.2-.2 0-.5.1-.8.2-.3.1-.5.3-.9.6L18.3 30c.4-.4.7-.6 1-.8.3-.2.6-.3.9-.4s.7-.1 1.1-.1c.5 0 1 .1 1.4.3.4.2.7.4.9.8.2.3.3.7.3 1.1 0 .3 0 .6-.1.9s-.2.5-.4.8c-.2.3-.4.5-.6.8s-.8.8-1.7 1.6h3v1.7z" />
		</svg>
	);
};
